import { render, staticRenderFns } from "./BasicData.vue?vue&type=template&id=bf711b14&scoped=true"
import script from "./BasicData.vue?vue&type=script&lang=js"
export * from "./BasicData.vue?vue&type=script&lang=js"
import style0 from "./BasicData.vue?vue&type=style&index=0&id=bf711b14&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf711b14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf711b14')) {
      api.createRecord('bf711b14', component.options)
    } else {
      api.reload('bf711b14', component.options)
    }
    module.hot.accept("./BasicData.vue?vue&type=template&id=bf711b14&scoped=true", function () {
      api.rerender('bf711b14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dataBoard/components/BasicData.vue"
export default component.exports